import moment from 'moment'
// import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { getSearchParams, getSearchResults, search, getHotelAmenities, getHotelTypes, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByHotDeal,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    rooms: [{ adults: 2, childAges: [] }],
    countryName: '',
    resortName: ''
  },
  results: [],
  fees: {},

  generateFees () {
    const fees = {}
    for (let i = 5; i >= 0; i--) {
      fees[i] = {
        percent: 0,
        value: 0
      }
    }
    return fees
  },

  saveFees () {
    localStorage.setItem('hotelFees', JSON.stringify(this.fees))
  },

  async init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    const initialRequests = [
      getSearchParams({ dc: this.distribution }),
      getSearchResults({ dc: this.distribution }),
      getHotelAmenities(),
      getRoomAmenities(),
      getHotelThemes(),
      getHotelTypes()
    ]
    const res = await Promise.all(initialRequests)
    this.params = res[0]
    this.results = res[1]
    const hotelFees = localStorage.getItem('hotelFees')
    if (hotelFees) this.fees = JSON.parse(hotelFees)
    else this.fees = this.generateFees()
    this.hotelAmenities = res[2]
    this.roomAmenities = res[3]
    this.hotelThemes = res[4]
    this.hotelTypes = res[5]
    this.initDataLoaded = true
    return true
  },
  getDuration () {
    const checkout = moment(this.params.checkOut, 'DD-MM-YYYY')
    const checkin = moment(this.params.checkIn, 'DD-MM-YYYY')
    return checkout.startOf('day').diff(checkin.startOf('day'), 'days')
  },
  getNoPax () {
    return this.getNoAdults() + this.getNoChildren()
  },
  getNoAdults () {
    return this.params.rooms.reduce((acc, room) => acc + room.adults, 0)
  },
  getNoChildren () {
    return this.params.rooms.reduce((acc, room) => acc + room.ages.length, 0)
  },
  sort ({ sortMethod = this.sort }) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ dc: this.distribution })
    this.params = newParams
    this.results = res
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
